import React from 'react'
import { Context as StoreContext } from './Store'
import { bundlesAPI, currenciesAPI, clientsAPI, suppliersAPI, vendorsAPI, productsAPI, warehousesAPI, inventoriesAPI, citiesAPI, statesAPI, countriesAPI, metricsAPI, platformstatusesAPI, platformcostcalculationsAPI  } from '../api'
import pagesIndex from '../pages-index'

export const Context = React.createContext({
	current: false,
	recall: false,
	setRecall: () => {},
	vendor: null,
	vendorChange: () => {},
	vendors:[],
	address: {
		cities: [],
		states: [],
		countries: [],
	},
	bundles: {
		bundles:[],
		create: () => {},
		detail: () => {},
		update: () => {},
		remove: () => {},
	},
	platformstatuses: {
		platformstatuses:[],
		create: () => {},
		detail: () => {},
		update: () => {},
		remove: () => {},
	},
	platformcostcalculations: {
		platformcostcalculations:[],
		upsert: () => {},
	},
	suppliers:{
		suppliers:[],
		create: () => {},
		update: () => {},
	},
	clients: {
		clients:[],		
		create: () => {},
		detail: () => {},
		update: () => {},
		metrics:() => {},
		factoring:() => {},
		externalwarehousing_detail:() => {},
		pick_and_pack:() => {},
		onlyEvents:() => {},
	},
	currencies: {
		currencies:[],
		detail: () => {},
	},
	products: {
		allProducts:[],
		products:[],
		totalProducts: 0,
		refresh: () => {},
		create: () => {},
		productKeys:{},
		getProducts: () => {},
		selectedProducts:false,
		setSelectedProducts:() => {},
		selectedProduct:false,
		setSelectedProduct:() => {},
		assignCurrency:() => {},
		assignClient:() => {},
		assignSupplier:() => {},
		assignDiscount:() => {},
		assignSeason:() => {},
		assignCost:() => {},
		assignDimensions:() => {},
		deleteProducts:() => {},
		updateListings:() => {},
		productBulkUpdate: () => {},
	},
	warehouses: {
		warehouses:[],
		warehouse: null,
		warehouseChange: () => {},
		create: () => {},
		detail: () => {},
		update: () => {},
		remove: () => {},
	},
	inventories: {
		inventories:[],
		refresh: () => {},
		create: () => {},
		detail: () => {},
		quantity: () => {},
		update: () => {},
		remove: () => {},
		
		capital: () => {},
	},
	metrics: {
		productMetrics: null
	}
})

export const Provider = ({source, ...rest}) => {
	const { neededData } = pagesIndex()
	const { store } = React.useContext(StoreContext)

	const [current, setCurrent] = React.useState(false)
	const [recall, setRecall] = React.useState(false)

	const [cities, setCities] = React.useState([])
	const [states, setStates] = React.useState([])
	const [countries, setCountries] = React.useState([])

	const [productMetrics, setProductMetrics] = React.useState(null)

	const [bundles, setBundles] = React.useState([])
	const [platformstatuses, setPlatformStatuses] = React.useState([])
	const [platformcostcalculations, setPlatformCostCalculations] = React.useState([])
	const [vendors, setVendors] = React.useState([])
	const [vendor, setVendor] = React.useState(null)
	const [suppliers, setSuppliers] = React.useState([])
	const [currencies, setCurrencies] = React.useState([])
	const [clients, setClients] = React.useState([])
	const [warehouse, setWarehouse] = React.useState(null)
	const [warehouses, setWarehouses] = React.useState([])
	const [inventories, setInventories] = React.useState([])
	const [products, setProducts] = React.useState([])
	const [allProducts, setAllProducts] = React.useState([])

	const [selectedProduct, setSelectedProduct] = React.useState(false)
	const [selectedProducts, setSelectedProducts] = React.useState(false)


	React.useEffect(() =>{
		vendorsAPI.list(setVendors)

		if(neededData.currencies.includes(window.location.pathname))
			currenciesAPI.list(setCurrencies)

		if(neededData.clients.includes(window.location.pathname))
			clientsAPI.list(setClients)
		
		if(neededData.suppliers.includes(window.location.pathname))
			suppliersAPI.list(setSuppliers)
		
		if(neededData.products.includes(window.location.pathname))
			productsAPI.list(groupProducts)
	
		if(neededData.bundles.includes(window.location.pathname))
			bundlesAPI.list(setBundles)
		
		if(neededData.platformstatuses.includes(window.location.pathname))
			platformstatusesAPI.list((pss) => setPlatformStatuses(pss.sort((ps1, ps2) => 
				ps1.type > ps2.type? 1:
				ps1.type < ps2.type? -1:
				ps1.name > ps2.name? 1:
				ps1.name < ps2.name? -1: 0
		)))
		
		if(neededData.platformcostcalculations.includes(window.location.pathname))
			platformcostcalculationsAPI.list(setPlatformCostCalculations)

		if(neededData.warehouses.includes(window.location.pathname))
			warehousesAPI.list(setWarehouses)
		
		if(neededData.inventories.includes(window.location.pathname))
			inventoriesAPI.list(setInventories)
		
		if(neededData.address.includes(window.location.pathname)){
			citiesAPI.list(setCities)
			statesAPI.list(setStates)
			countriesAPI.list(setCountries)
		}

		if(neededData.metrics.includes(window.location.pathname)){
			metricsAPI.products(setProductMetrics)
		}

	}, [store])

	function parseListings(ps) {
		const _products = {}
		ps.forEach(p => {
			if(_products[p.sku]){
				_products[p.sku].filter += `, ${p.filter}`
				_products[p.sku].asin += `, ${p.asin}`
				_products[p.sku].name += ` |-----| ${p.name}`
				_products[p.sku].fulfillment += `, ${p.fulfillment}`
				_products[p.sku].status += `, ${p.status}`
				_products[p.sku].listings.push(p)
			}
			else _products[p.sku] = {
				...p,
				listings:[p]
			}
		})
		return _products
	}

	function groupProducts(ps) {
		setAllProducts(ps)
		const _products = parseListings(ps)
		setProducts(Object.keys(_products).sort((sku1, sku2) => 
			_products[sku1].name > _products[sku2].name? 1:
			_products[sku1].name < _products[sku2].name? -1: 0
		).map(sku => _products[sku]))
	}

	const _metrics = {
		productMetrics,
	}

	const _address = {
		cities,
		states,
		countries,
	}

	const _warehouses = {
		warehouses,
		warehouse,
		warehouseChange: (e) => {
			setWarehouse((e.target || e.currentTarget).value)
		},
		create: (warehouse) => {
			warehousesAPI.create(warehouse, (createdWarehouse) => {
				setWarehouses([...warehouses, createdWarehouse])
			})
			setRecall(false)
		},
		detail: (inv) => {
			setCurrent(inv)
		},
		update: (_warehouse) => {
			warehousesAPI.update(current.id, _warehouse, (updatedBundle) => {
				setWarehouses([...warehouses.map(wh => wh.id === current.id?updatedBundle:wh)])
				setCurrent(null)
			})
			setRecall(false)
		},
		remove: (whid) => {
			warehousesAPI.delete(whid, () => {
				setWarehouses(warehouses.filter(wh => wh.id !== whid))
			})
			setCurrent(false)
		},
	}
	
	const _inventories = {
		inventories,
		refresh: () => inventoriesAPI.list(setInventories),
		create: (inventory) => {
			inventoriesAPI.create(inventory, (createdInventory) => {
				setInventories([...inventories, createdInventory])
			})
			setRecall(false)
		},
		detail: (inv) => {
			setCurrent(inv)
		},
		quantity: (inv, quantity, cb, err) => {
			inventoriesAPI.quantity(inv, {quantity}, cb, err)
		},
		update: (_inventory) => {
			inventoriesAPI.update(current.id, _inventory, (updatedBundle) => {
				setInventories([...inventories.map(b => b.id === current.id?updatedBundle:b)])
				setCurrent(null)
			})
			setRecall(false)
		},
		remove: (scid) => {
			inventoriesAPI.delete(scid, () => {
				setInventories(inventories.filter(sc => sc.id !== scid))
			})
			setCurrent(false)
		},
		capital: (data, cb, error) => {
			inventoriesAPI.capital(data, (res) => {
				cb(res.download)
			}, error)
		}
	}

	const _suppliers = {
		suppliers,
		create: (_supplier) => {
			suppliersAPI.create(_supplier, (createdsupplier) => {
				const newsuppliers = [...suppliers, createdsupplier]
				setSuppliers(newsuppliers)
			})
			setRecall(false)
		},
		detail: (detailedsupplier) => {
			setCurrent(detailedsupplier)
		},
		update: (_supplier) => {
			suppliersAPI.update(current.id, _supplier, (updatedSupplier) => {
				setSuppliers([...suppliers.map(c => c.id === updatedSupplier.id?updatedSupplier:c)])
				setCurrent(null)
			})
			setRecall(false)
		},
	}


	const _bundles = {
		bundles,
		create: (bundle) => {
			bundlesAPI.create(bundle, (createdBundle) => {
				setBundles([...bundles, createdBundle])
			})
			setRecall(false)
		},
		detail: (bnd) => {
			setCurrent(bnd)
		},
		update: (_bundle) => {
			bundlesAPI.update(current.id, _bundle, (updatedBundle) => {
				setBundles([...bundles.map(b => b.id === current.id?updatedBundle:b)])
				setCurrent(null)
			})
			setRecall(false)
		},
		remove: (scid) => {
			bundlesAPI.delete(scid, () => {
				setBundles(bundles.filter(sc => sc.id !== scid))
			})
			setCurrent(false)
		},
	}

	const _platformstatuses = {
		platformstatuses,
		create: (platformstatus) => {
			platformstatusesAPI.create(platformstatus, (createdPlatformStatus) => {
				setPlatformStatuses([...platformstatuses, createdPlatformStatus])
			})
			setRecall(false)
		},
		detail: (ps) => {
			setCurrent(ps)
		},
		update: (_platformStatus) => {
			platformstatusesAPI.update(current._id, _platformStatus, (updatedPlatformStatus) => {
				setPlatformStatuses([...platformstatuses.map(b => b.id === current.id?updatedPlatformStatus:b)])
				setCurrent(null)
			})
			setRecall(false)
		},
		remove: (psid) => {
			platformstatusesAPI.delete(psid, () => {
				setPlatformStatuses(platformstatuses.filter(sc => sc._id !== psid))
			})
			setCurrent(false)
		},
	}

	const _platformcostcalculations = {
		platformcostcalculations,
		upsert: (platformcostcalculations, onSuccess, onError) => {
			platformcostcalculationsAPI.upsert(platformcostcalculations, (allplatformcostcalculations) => {
				console.log({allplatformcostcalculations})
				setPlatformCostCalculations(allplatformcostcalculations)
				onSuccess()
			}, onError)
		},
	}

	const _currencies = {
		currencies,
		create: (_currency) => {
			currenciesAPI.create(_currency, (createdCurrency) => {
				const newCurrencies = [...currencies, createdCurrency]
				setCurrencies(newCurrencies)
			})
			setRecall(false)
		},
		update: (_currency) => {
			currenciesAPI.update(current.id, _currency, (updatedCurrency) => {
				setCurrencies([...currencies.map(c => c.id === updatedCurrency.id?updatedCurrency:c)])
				setCurrent(null)
			})
			setRecall(false)
		},
		detail: (currency) => {
			setCurrent(currency)
		},
	}

	const _clients = {
		clients,
		create: (_client) => {
			clientsAPI.create(_client, (createdClient) => {
				const newClients = [...clients, createdClient]
				setClients(newClients)
			})
			setRecall(false)
		},
		detail: (detailedClient) => {
			setCurrent(detailedClient)
		},
		update: (_client) => {
			clientsAPI.update(current.id, _client, (updatedClient) => {
				setClients([...clients.map(c => c.id === updatedClient.id?updatedClient:c)])
				setCurrent(null)
			})
			setRecall(false)
		},
		metrics:(id, m,) => clientsAPI.metrics(id, {metrics:m}, (updatedClient) => {
			setClients([...clients.map(c => c.id === updatedClient.id?updatedClient:c)])
		}),
		externalwarehousing_detail:(id, w,) => clientsAPI.externalwarehousing_detail(id, {externalwarehousing_detail:w}, (updatedClient) => {
			setClients([...clients.map(c => c.id === updatedClient.id?updatedClient:c)])
		}),
		pick_and_pack:(id, w,) => clientsAPI.pick_and_pack(id, {pick_and_pack:w}, (updatedClient) => {
			setClients([...clients.map(c => c.id === updatedClient.id?updatedClient:c)])
		}),
		factoring:(id, f,) => clientsAPI.factoring(id, {factoring:f}, (updatedClient) => {
			setClients([...clients.map(c => c.id === updatedClient.id?updatedClient:c)])
		}),
		onlyEvents:(id, w,) => clientsAPI.onlyEvents(id, {onlyEvents:w}, (updatedClient) => {
			setClients([...clients.map(c => c.id === updatedClient.id?updatedClient:c)])
		}),
	}

	const productKeys = products.reduce((pvo,p) => {pvo[p.id]=p.listings.reduce((pva, l) => {pva.push(l.id); return pva},[]);return pvo},{})
	const _products = {
		allProducts,
		products,
		totalProducts: products.length,
		refresh: () => productsAPI.list(groupProducts),
		create: (product) => {
			productsAPI.create(product, (createdProduct) => {
				setProducts([...products, createdProduct])
			})
			setRecall(false)
		},
		productKeys,
		getProducts: (pids) => {
			return products.filter(p => pids.includes(p.id))
		},
		applyChanges: (changes) => {
			const changed = products.filter(p => selectedProducts.includes(p.id)).map(p => ({
				...p, 
				...changes, 
				listings: p.listings.map(l => ({...l, ...changes}))
			}))
			setProducts(products.map(p => selectedProducts.includes(p.id)?changed.find(c => c.id === p.id):p))
		},
		replaceProduct: (updatedProducts) => {
			groupProducts(allProducts.map(p => updatedProducts.find(up => up.id === p.id) || p))
		},
		selectedProduct,
		setSelectedProduct:(product) => {
			setSelectedProducts(false)
			setSelectedProduct(product)
		},
		selectedProducts,
		setSelectedProducts:(pids) => {
			if(pids && pids.length){
				setSelectedProducts(pids)
				setSelectedProduct(false)
			}
			else setSelectedProducts(false)
		},
		assignCurrency: (cid) => {
			const productsToUpdate = []
			_products.getProducts(selectedProducts).forEach(pc => pc.listings.forEach(l => productsToUpdate.push(l.id)) )
			console.log("Assigning client ", cid, " to products ", {productsToUpdate})
			productsAPI.assignCurrency({products:productsToUpdate, currency:cid}, (currency) => _products.applyChanges({currency, currencyId: currency.id}))
		},
		assignClient: (cid) => {
			const productsToUpdate = []
			_products.getProducts(selectedProducts).forEach(pc => pc.listings.forEach(l => productsToUpdate.push(l.id)) )
			console.log("Assigning client ", cid, " to products ", {productsToUpdate})
			productsAPI.assignClient({products:productsToUpdate, client:cid}, (client) => _products.applyChanges({client, clientId: client.id}))
		},
		assignSupplier: (sid) => {
			const productsToUpdate = []
			_products.getProducts(selectedProducts).forEach(pc => pc.listings.forEach(l => productsToUpdate.push(l.id)) )
			console.log("Assigning supplier ", sid, " to products ", {productsToUpdate})
			productsAPI.assignSupplier({products:productsToUpdate, supplier:sid}, (supplier) => _products.applyChanges({supplier, supplierId: supplier.id}))
		},
		assignDiscount:(discount) => {
			const productsToUpdate = []
			_products.getProducts(selectedProducts).forEach(pc => pc.listings.forEach(l => productsToUpdate.push(l.id)) )
			console.log("Assigning discount", discount, "to products", {productsToUpdate})
			productsAPI.assignDiscount({products:productsToUpdate, discount}, ({discount, discount_elements, includes_tax}) => _products.applyChanges({discount, discount_elements, includes_tax}))
		},
		assignSeason:(season) => {
			const productsToUpdate = []
			_products.getProducts(selectedProducts).forEach(pc => pc.listings.forEach(l => productsToUpdate.push(l.id)) )
			console.log("Assigning season", season, "to products", {productsToUpdate})
			productsAPI.assignSeason({products:productsToUpdate, season}, ({season, season_elements}) => _products.applyChanges({season, season_elements}))
		},
		assignCost:(cost) => {
			const productsToUpdate = []
			_products.getProducts(selectedProducts).forEach(pc => pc.listings.forEach(l => productsToUpdate.push(l.id)) )
			console.log("Assigning cost", cost, "to products", {productsToUpdate})
			productsAPI.assignCost({products:productsToUpdate, cost}, ({cost}) => _products.applyChanges({cost}))
		},
		assignDimensions:(dimensions) => {
			const productsToUpdate = []
			_products.getProducts(selectedProducts).forEach(pc => pc.listings.forEach(l => productsToUpdate.push(l.id)) )
			console.log("Assigning dimensions", dimensions, "to products", {productsToUpdate})
			productsAPI.assignDimensions({products:productsToUpdate, ...dimensions}, _products.replaceProduct)
		},
		deleteProducts:(cost) => {
			const productsToUpdate = []
			_products.getProducts(selectedProducts).forEach(pc => pc.listings.forEach(l => productsToUpdate.push(l.id)) )
			console.log("Deleting products", {productsToUpdate})
			productsAPI.deleteProducts({products:productsToUpdate}, (deletedProducts) =>  {
				setProducts([
					...products.filter(p => !deletedProducts[p.id])
				])
			})
		},
		updateListings:(data, cb, error) => {
			productsAPI.updateListings(data, cb, error)
		},
		productBulkUpdate:(data, cb, error) => {
			productsAPI.productBulkUpdate(data, (res) => {
				cb(res.download)
			}, error)
			
		},
	}

	const vendorChange = (e) => {
		setVendor((e.target || e.currentTarget).value)
	}
	
	
	return (
		<Context.Provider value={{
			current,
			recall,
			setRecall,
			vendors,
			vendor,
			vendorChange,
			suppliers:_suppliers,
			bundles:_bundles,
			platformcostcalculations:_platformcostcalculations,
			platformstatuses:_platformstatuses,
			currencies:_currencies,
			clients:_clients,
			products:_products,
			warehouses: _warehouses,
			inventories: _inventories,
			address: _address,
			metrics: _metrics,
		}}>
			{rest.children}
		</Context.Provider>
	)
}